import React from 'react'

import ActionButton from '@/components/misc/ActionButton'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from '@/components/ui/dialog'

interface Props {
  companyName: string
  onBooked: () => void
  onNoBooked: () => void
  onHide: () => void
  isProcessing: boolean
}

const DidYouBookTheMeetingModal: React.FC<Props> = ({
  companyName,
  onBooked,
  onNoBooked,
  onHide,
  isProcessing,
}) => {
  return (
    <Dialog open onHide={onHide}>
      <DialogContent>
        <DialogHeader></DialogHeader>

        <DialogBody>
          Did you book a meeting with <strong>{companyName}</strong>?
        </DialogBody>

        <DialogFooter>
          <Button variant="outline-secondary" onClick={onNoBooked}>
            No
          </Button>

          <ActionButton
            variant="success"
            isProcessing={isProcessing}
            isProcessingText="Creating referral"
            onClick={onBooked}
          >
            Yes
          </ActionButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default DidYouBookTheMeetingModal
